export default {
	albumByUPC: (upc: string) => `/albums/${upc}`,
	albumTracks: (upc: string) => `/albums/${upc}/tracks`,
};
